export default __webpack_public_path__ + "static/media/info_bonus.min.0c64909d.png";